import React from 'react';
import PropTypes from 'prop-types';
import { classnames } from 'Utils/classnames';
import { Button } from 'Components/Button';

const Message = ({ children, type, buttonConfig, buttonAlign, hasIcon }) => {
  const iconClass = classnames({
    status__icon: true,
    [`status__icon--${type}`]: type
  });

  const alignClass = classnames({
    'status__buttons-group': true,
    'status__buttons-group--vertical': buttonAlign === 'vertical'
  });

  const { primary, secondary, tertiary } = buttonConfig || {};

  const primaryButtonClass = classnames({
    'btn--primary btn--half-round-group': true,
    [primary?.className]: primary?.className
  });

  const secondaryButtonClass = classnames({
    'btn--outline btn--half-round-group': true,
    [secondary?.className]: secondary?.className,
  });

  const tertiaryButtonClass = classnames({
    'btn--outline btn--half-round-group': true,
    [tertiary?.className]: tertiary?.className
  });

  const statusTextClass = classnames({
    status__text: true,
    'status__text-no-icon': !hasIcon
  });

  const icon = hasIcon === false ? null : <div className={ iconClass } />;

  const primaryActionButton = primary
    ? (<div className='status__buttons'>
      <Button
        title={ primary.label }
        disabled={ primary.disabled }
        className={ primaryButtonClass }
        onClick={ primary.onClick || null }>
        { primary.label }
      </Button>
    </div>)
    : null;

  const secondaryActionButton = secondary
    ? (<div className='status__buttons'>
      <Button
        title={ secondary.label }
        disabled={ secondary.disabled }
        className={ secondaryButtonClass }
        onClick={ secondary.onClick || null }>{ secondary.label }</Button>
    </div>)
    : null;

  const tertiaryActionButton = tertiary
    ? (<div className='status__buttons'>
      <Button
        title={ tertiary.label }
        disabled={ tertiary.disabled }
        className={ tertiaryButtonClass }
        onClick={ tertiary.onClick || null }>{ tertiary.label }</Button>
    </div>)
    : null;

  return (
    <>
      <div className='status'>
        { icon }

        <div className={ statusTextClass }>
          { children }
        </div>
      </div>
      <div className={ alignClass }>
        { primaryActionButton }

        { secondaryActionButton }

        { tertiaryActionButton }
      </div>
    </>
  );
};

Message.propTypes = {
  children: PropTypes.node,
  type: PropTypes.string.isRequired,
  buttonConfig: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.bool,
  ]),
  buttonAlign: PropTypes.string,
  hasIcon: PropTypes.bool
};

export default Message;
